import { addOrUpdateItem, clearCart, removeItem, removeEvent, updateSpecialItem, replaceItem } from '@/api/order';

export default {
  namespaced: true,
  state: {
    cart: [],
  },

  getters: {
    getCart: (state) => state.cart,
    getBag: (state) => {
      const bag = state.cart.filter((e) => {
        return e.item.value === 'SP00000000';
      });
      return bag[0];
    },
  },

  mutations: {
    SET_CART_DATA(state, data) {
      state.cart = data;
    },
    ADD_OR_UPDATE_CART_DATA(state, data) {
      data.forEach((item) => {
        const index = state.cart.findIndex((el) => el.item_id === item.item_id);
        // console.log(index);
        if (index === -1) {
          state.cart.push(item);
        } else {
          state.cart.splice(index, 1, item);
        }
      });
    },
    REMOVE_CART_DATA(state, item_id) {
      const index = state.cart.findIndex((el) => el.item_id === item_id);
      state.cart.splice(index, 1);
    },
    RESET(state) {
      state.cart = [];
    },
  },

  actions: {
    //加入或複製品項
    async doHandleCartItem({ commit, rootGetters }, action) {

      const data = rootGetters['menuItem/getMenuItem'];
      const order_id = rootGetters['order/getOrderId'];
      let res;
      /* action=
      addCopyItem - 複製 -> 直接複製一個一模一樣的品項到購物車，同時detail頁面呈現新品項
      copy - 加入(儲存)並新增同項 -> 加入或儲存之後，在detail頁面保存一個全新未加入的該品項(沒有複製品項到購物車)
      noCopy -加入(儲存) -> 加入或儲存之後，detail頁面清空
      */
      console.log(" doHandleCartItem item", data);
      //判斷是不是複製品項
      console.debug("item", data);
      if (action === 'addCopyItem') {
        const copyOne = JSON.parse(JSON.stringify(data));
        copyOne.item_id = null;
        copyOne.discounts = [];
        copyOne.note = null;
        res = await addOrUpdateItem({ ...copyOne, order_id });
      } else {
        res = await addOrUpdateItem({ ...data, order_id });
      }
      // console.log(res);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve(res.new_add_to_cart[0]);
    },
    //加入推薦的品項(會員功能)
    async doAddRecommendItem({ commit, rootGetters }, item) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await addOrUpdateItem({ ...item, order_id });
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve(res.new_add_to_cart[0]);
    },
    //加入購物袋(for結帳介面快速按鈕)
    async doAddBags({ commit, rootGetters }, item) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await updateSpecialItem({ ...item, order_id });
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve(res.new_add_to_cart[0]);
    },
    //清空購物車
    async doClearCart({ commit, rootGetters }) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await clearCart({ order_id });
      // console.log(res);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', []);
      return Promise.resolve();
    },
    //刪除品項
    async doRemoveItem({ commit, rootGetters }, item_id) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await removeItem({ order_id, item_id });
      // console.log(res);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve();
    },
    //刪除活動
    async doRemoveEvent({ commit, rootGetters }, form_source_code) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await removeEvent({ order_id, form_source_code });
      // console.log(res);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve();
    },
    //更新品項
    async doReplaceItem({ commit, rootGetters }, item) {
      const item_id = rootGetters['menuItem/getItemId'];
      const order_id = rootGetters['order/getOrderId'];
      const payload = {
        item_id,
        order_id,
        item,
      };
      const res = await replaceItem(payload);
      // console.log(res);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve();
    },
    //更新品項數量
    async doUpdateItemQuantity({ commit, rootGetters }, { item }) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await addOrUpdateItem({ ...item, order_id });
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('SET_CART_DATA', res.cart);
      return Promise.resolve();


      // return Promise.resolve(res.new_add_to_cart[0]);
    },
  },
};
